import React, { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import { components } from "react-select";

export default function CreateTages({
  label,
  options: initialOptions = [],
  placeholder,
  onChangeValue,
  onBlur,
  required,
  value,
}) {
  const [options, setOptions] = useState(initialOptions);
  const [selectedOption, setSelectedOption] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const DropdownIndicator = () => null;  

const handleChange = (newValue) => {
  setSelectedOption(newValue || []);
  if (onChangeValue) onChangeValue(newValue || []);
};

// Helper function to remove duplicates by value
const uniqueByValue = (arr) => {
  const seen = new Set();
  return arr.filter((item) => {
    if (seen.has(item.value)) return false;
    seen.add(item.value);
    return true;
  });
};

const handleCreate = (inputValue) => {
  const newOption = { value: inputValue, label: inputValue };

  setOptions((prev) => uniqueByValue([...prev, newOption]));

  const updatedSelection = uniqueByValue([...(selectedOption || []), newOption]);
  setSelectedOption(updatedSelection);
  if (onChangeValue) onChangeValue(updatedSelection);
  setMenuOpen(false);
};

useEffect(() => {
  if (!Array.isArray(initialOptions)) return;

  setOptions(initialOptions);

  if (Array.isArray(value)) {
    const formatted = value.map((val) =>
      typeof val === "string" ? { value: val, label: val } : val
    );

    // Add missing options, but keep unique
    const missingOptions = formatted.filter(
      (val) => !initialOptions.some((opt) => opt.value === val.value)
    );

    if (missingOptions.length > 0) {
      setOptions((prev) => uniqueByValue([...prev, ...missingOptions]));
    }

    setSelectedOption(uniqueByValue(formatted));
  } else {
    setSelectedOption([]);
  }
}, [initialOptions, value]);

  const MenuList = (props) => {
    return (
      <components.MenuList {...props}>
        {React.Children.map(props.children, (child) => {
          if (!React.isValidElement(child)) return child;
          const option = child.props?.data;
          if (!option) return child;

          return (
            <div
              key={option.value}
              onClick={() => {
                if (!option.disabled) {
                  setMenuOpen(false);
                }
              }}
              className="custom-option d-flex justify-content-between align-items-center"
              style={{
                cursor: option.disabled ? "not-allowed" : "pointer",
                // borderBottom: "1px solid #f5f5f5",
                opacity: option.disabled ? 0.6 : 1,
              }}
            >
              {child}
            </div>
          );
        })}
      </components.MenuList>
    );
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "unset",
      height: "auto",
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    clearIndicator: (provided) => ({
      ...provided,
      padding: 4,
      cursor: "pointer",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: 4,
      cursor: "pointer",
    }),
  };
const CustomMultiValue = (props) => {
  return (
    <components.MultiValue {...props} className="selected-tag" />
  );
};
  return (
    <div className="form-group dropdoenlistcompany">
      <label>
        {label} {required && <small>*</small>}
      </label>
     <CreatableSelect
        isMulti
        isClearable
        value={selectedOption}
        onChange={handleChange}
        onCreateOption={handleCreate}
        options={options}
        styles={customStyles}
        components={{ MultiValue: CustomMultiValue, MenuList, DropdownIndicator }}
        placeholder={placeholder}
        onBlur={(event) => {
          if (onBlur) {
            onBlur(selectedOption);
          }
        }}
        classNamePrefix="my-custom"
      />

    </div>
  );
}
